export default class CarouselScale {
	constructor(flkty, carousel) {
		this.DOM = {carousel};
		this.flkty = flkty;
		this.totalSlides = flkty?.cells?.length || 0;

		this.initEvents();
	}
	initEvents() {
		this.flkty.on('select', () => {
			const previousSlide = this.flkty.selectedIndex === 0 ? this.totalSlides - 1 : this.flkty.selectedIndex - 1;
			const nextSlide = this.flkty.selectedIndex === this.totalSlides - 1 ? 0 : this.flkty.selectedIndex + 1;
			const previousSlideImage = this.flkty.cells[previousSlide].element.querySelector('.carousel__slide-inner');
			const nextSlideImage = this.flkty.cells[nextSlide].element.querySelector('.carousel__slide-inner');

			previousSlideImage.style.transformOrigin = 'right';
			nextSlideImage.style.transformOrigin = 'left';
		});
	}
}
